import { QueryClient } from "@tanstack/react-query";
import axios from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error)) {
          const status = error.response?.status;
          return (!status || status >= 500) && failureCount < 2;
        }
        return failureCount < 2;
      },
      retryDelay: 500,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
